import React, { useState, useEffect } from 'react';
import { Container, Box, TextField, Button, Typography, MenuItem } from '@mui/material';
import authService from '../services/authService';

const regions = [
  { value: 'us-east-1', label: 'US East (N. Virginia)' },
  { value: 'us-east-2', label: 'US East (Ohio)' },
  { value: 'us-west-1', label: 'US West (N. California)' },
  { value: 'us-west-2', label: 'US West (Oregon)' },
];

const textFieldStyles = {
  '& .MuiInputLabel-root': {
    color: '#fff',          // White label text
  },
  '& .MuiOutlinedInput-root': {
    color: '#fff',          // White input text
    '& fieldset': {
      borderColor: '#fff',  // White outline
    },
    '&:hover fieldset': {
      borderColor: '#fff',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#fff',
    },
  },
};

const SettingsPage = () => {
  const [awsAccessKey, setAwsAccessKey] = useState('');
  const [awsSecretKey, setAwsSecretKey] = useState('');
  const [awsRegion, setAwsRegion] = useState('');
  const [message, setMessage] = useState('');

  useEffect(() => {
    // Load existing credentials from localStorage if available
    const user = JSON.parse(localStorage.getItem('user'));
    if (user) {
      setAwsAccessKey(user.awsAccessKey || '');
      setAwsSecretKey(user.awsSecretKey || '');
      setAwsRegion(user.region || '');
    }
  }, []);

  const handleSave = async () => {
    await authService.updateAWSCredentials({
      awsAccessKey,
      awsSecretKey,
      region: awsRegion,
    });
    setMessage('Settings saved successfully.');
  };

  return (
    <Container sx={{ mt: 4 }}>
      <Typography variant="h5" gutterBottom sx={{ color: '#fff' }}>
        Settings
      </Typography>
      <Box sx={{ mt: 2 }}>
        <TextField
          label="AWS Access Key"
          variant="outlined"
          fullWidth
          margin="normal"
          value={awsAccessKey}
          onChange={(e) => setAwsAccessKey(e.target.value)}
          sx={textFieldStyles}
        />
        <TextField
          label="AWS Secret Key"
          variant="outlined"
          fullWidth
          margin="normal"
          type="password"
          value={awsSecretKey}
          onChange={(e) => setAwsSecretKey(e.target.value)}
          sx={textFieldStyles}
        />
        <TextField
          select
          label="AWS Region"
          variant="outlined"
          fullWidth
          margin="normal"
          value={awsRegion}
          onChange={(e) => setAwsRegion(e.target.value)}
          sx={textFieldStyles}
        >
          {regions.map((option) => (
            <MenuItem key={option.value} value={option.value} sx={{ color: '#000' }}>
              {option.label}
            </MenuItem>
          ))}
        </TextField>
        <Button variant="contained" sx={{ mt: 2 }} onClick={handleSave}>
          Save Settings
        </Button>
        {message && (
          <Typography sx={{ mt: 2, color: '#fff' }}>
            {message}
          </Typography>
        )}
      </Box>
    </Container>
  );
};

export default SettingsPage;
